import React from 'react'
import { useTheme } from 'styled-components'

import { Accordion, AccordionItem, Button, Flex, H5, P } from 'ui/bend'
import { SubscribeProvider } from 'context'

import RenewStripeForm from './Renewing/RenewStripeForm'
import { useActiveMembershipContext } from '../ActiveMembershipStore'
import { humanReadableDate, humanReadableTime } from './formatTimes'

const Churning = () => {
  const { colors } = useTheme()
  const { membershipInfo } = useActiveMembershipContext()

  const { subscriptionEndTime, subscriptionSource, isFlexUser } = membershipInfo

  const date = new Date(subscriptionEndTime)
  const getHumanDate = () => humanReadableDate(date)
  const getHumanTime = () => humanReadableTime(date)

  const mobileProvider =
    subscriptionSource === 'ios'
      ? 'Apple'
      : subscriptionSource === 'google'
      ? 'Google Play'
      : ''

  const copy = (() => {
    switch (subscriptionSource) {
      case 'stripe': {
        return {
          title: 'Your membership is ending',
          body: `Your membership access is set to end${
            subscriptionEndTime
              ? ` on ${getHumanDate()} at ${getHumanTime()}`
              : ''
          }.`
        }
      }
      case 'ios':
      case 'google': {
        return {
          title: `Your ${mobileProvider} subscription has been cancelled and access is set to end${
            subscriptionEndTime ? ` on ${getHumanDate()}` : ''
          }`,
          body: `To continue access${
            subscriptionEndTime
              ? ` after ${getHumanDate()} at ${getHumanTime()}`
              : ''
          }, please activate a membership below.`
        }
      }
      default: {
        return {
          title: `Your access is set to end${
            subscriptionEndTime ? ` on ${getHumanDate()}` : ''
          }`,
          body: `To continue access${
            subscriptionEndTime
              ? ` after ${getHumanDate()} at ${getHumanTime()}`
              : ''
          }, please activate a membership below.`
        }
      }
    }
  })()

  return (
    <Flex flexDirection='column'>
      <H5 color='primary'>{copy.title}</H5>
      <P>{copy.body}</P>
      {subscriptionSource === 'stripe' ? (
        <SubscribeProvider forms={['membership']}>
          <Accordion>
            <AccordionItem
              title='Reactivate membership'
              id='settings-reactivate-membership'
              aria-controls='settings-membership-form'
            >
              <RenewStripeForm cta='Reactivate Membership' reactivate={true} />
            </AccordionItem>
          </Accordion>
        </SubscribeProvider>
      ) : (
        <Button
          as='a'
          href='/subscribe/membership'
          className='unstyled'
          style={{ color: colors.base }}
        >
          Activate Membership
        </Button>
      )}
    </Flex>
  )
}

export default Churning
